namespace Riepiloghi.Negozio {
    export interface RiepiloghiRow {
        IdRiepilogo?: number;
        Data?: string;
        Nominativo?: string;
        Venduto?: number;
        Vecchio?: number;
        Liquidi?: number;
        Pos?: number;
        Resta?: number;
        Boutique?: number;
        Albergo?: number;
        InseritoIl?: string;
        Totale?: number;
    }

    export namespace RiepiloghiRow {
        export const idProperty = 'IdRiepilogo';
        export const localTextPrefix = 'Negozio.Riepiloghi';
        export const deletePermission = 'Riepiloghi:Negozio';
        export const insertPermission = 'Riepiloghi:Negozio';
        export const readPermission = 'Riepiloghi:Negozio';
        export const updatePermission = 'Riepiloghi:Negozio';

        export declare const enum Fields {
            IdRiepilogo = "IdRiepilogo",
            Data = "Data",
            Nominativo = "Nominativo",
            Venduto = "Venduto",
            Vecchio = "Vecchio",
            Liquidi = "Liquidi",
            Pos = "Pos",
            Resta = "Resta",
            Boutique = "Boutique",
            Albergo = "Albergo",
            InseritoIl = "InseritoIl",
            Totale = "Totale"
        }
    }
}
